/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import { useQuery } from "@apollo/client";

import { FormattedDate, FormattedTime } from "react-intl";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
// import TableSortLabel from "@material-ui/core/TableSortLabel";

// import {
//   AutoSizer,
//   Column as RVColumn,
//   Table as RVTable,
//   TableCellRenderer,
//   TableHeaderProps,
//   InfiniteLoader,
//   IndexRange,
// } from "react-virtualized";

import { loader } from "graphql.macro";

import { mergeSeries } from "./trend-graph-utils";

import { Column } from "./table";

import { DataSeries } from "./flotmodel";
import { MetaData } from "./MetaData";

const TrendValues = loader("../graphql/TrendTableValues.graphql");

interface TrendTableProps {
  // nodes: any[];
  // chartData: any[];
  allData: DataSeries[]; // series options (except yaxes?) => TODO allData must be included in metaData.options
  // data: any[];
  metaData: MetaData; // general plot options
  // dataSeries: DataSeries[]; // actual data
  widgetStatic?: boolean;
  widgetTitle?: string;

  // from container:
  nodes?: any[];
  panelId?: string;
  startDate: number; // Date;
  endDate: number; // Date;
}

// const Root = (props: any) => (
//   <Grid.Root {...props} style={{ height: "100%" }} />
// );

// const VIRTUAL_PAGE_SIZE = 100; // TODO 100
// const MAX_ROWS = 50000;
// const getRowId = row => row.Id;
// const getRowId = (row: any) => row.time; // TODO is this ok?

// const initialState = {
//   rows: [],
//   skip: 0,
//   requestedSkip: 0,
//   take: VIRTUAL_PAGE_SIZE * 2,
//   totalCount: 0,
//   loading: false,
//   // lastQuery: '',
//   lastTake: -1,
//   lastSkip: -1,
//   lastStartDate: -1,
//   lastEndDate: -1,
// };

// function reducer(state: any, { type, payload }: any) {
//   switch (type) {
//     case "UPDATE_ROWS":
//       return {
//         ...state,
//         ...payload,
//         loading: false,
//       };
//     case "START_LOADING":
//       return {
//         ...state,
//         requestedSkip: payload.requestedSkip,
//         take: payload.take,
//       };
//     case "REQUEST_ERROR":
//       return {
//         ...state,
//         loading: false,
//       };
//     case "FETCH_INIT":
//       return {
//         ...state,
//         loading: true,
//       };
//     case "UPDATE_QUERY":
//       return {
//         ...state,
//         // lastQuery: payload,
//         lastTake: payload.take,
//         lastSkip: payload.skip,
//         lastStartDate: payload.startDate,
//         lastEndDate: payload.endDate,
//       };
//     default:
//       return state;
//   }
// }

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // minWidth: 500,
      height: "100%",
    },
  })
);

function TrendTableMui(props: TrendTableProps) {
  const classes = useStyles(props);
  // const { nodes, startDate, endDate } = props;
  const {
    // nodes,
    // chartData,
    allData,
    // metaData /*, data*/,
    // dataSeries,
    // widgetStatic,
    // from container:
    nodes,
    panelId,
    startDate,
    endDate,
  } = props;
  // console.log("TABLE: startDate", startDate, "endDate", endDate);

  const n = nodes ? nodes.map((n) => n.id).join(",") : undefined;

  // const [state, dispatch] = useReducer(reducer, initialState);
  // const client = useApolloClient();

  const [pageSize, setPageSize] = useState(10);
  // const [pageSizes, setPageSizes] = useState([5, 10, 15]);
  const [currentPage, setCurrentPage] = useState(0);
  // const [hiddenColumnNames, setHiddenColumnNames] = useState([] as string[]);

  // const page = currentPage;
  // const rowsPerPage = pageSize;
  // const [expandedRowIds, setExpandedRowIds] = useState([]);
  // const [columnWidths, setColumnWidths] = useState([] as TableColumnWidthInfo[]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    // setPage(newPage);
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    // setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  // const nodeIds = nodes.map(node => node.id);

  const otherColumns: Column[] = allData
    .filter((node) => node.tagId !== -1)
    .map((node: any, index: number) => {
      // const series = dataSeries.find(ser => ser.tagId === node.tagId);
      return {
        id: `${node.tagId}`,
        label: `${node.tagId === -1 ? "" : node.label || node.tagId}`,
        width: 128,
      };
    });

  // const getRemoteRows = (requestedSkip: number, take: number) => {
  //   dispatch({ type: "START_LOADING", payload: { requestedSkip, take } });
  // };

  // const loadData = () => {
  //   const {
  //     requestedSkip,
  //     take,
  //     lastQuery,
  //     lastSkip,
  //     lastTake,
  //     lastStartDate,
  //     lastEndDate,
  //     loading,
  //   } = state;
  //   // const query = buildQueryString(requestedSkip, take);
  //   if (
  //     /*query !== lastQuery &&*/ (lastSkip !== requestedSkip ||
  //       lastTake !== take ||
  //       lastStartDate !== startDate ||
  //       lastEndDate !== endDate) &&
  //     !loading
  //   ) {
  //     dispatch({ type: "FETCH_INIT" });
  //     const resultPromise = client
  //       .query({
  //         query: TrendValues,
  //         variables: {
  //           panelId,
  //           nodes: n,
  //           startDate,
  //           endDate,
  //           skip: requestedSkip,
  //           take,
  //         }, // FIXME requestedSkip, take
  //       })
  //       .then(({ data }: any) => {
  //         const m = mergeSeries(data.dataSeries).sort(
  //           (a, b) => b.time - a.time
  //         );
  //         // console.log("will fire UPDATE_ROWS with ", data, "merged: ", m);
  //         dispatch({
  //           type: "UPDATE_ROWS",
  //           payload: {
  //             skip: requestedSkip,
  //             rows: m,
  //             totalCount: m.length < take ? requestedSkip + m.length : MAX_ROWS,
  //           },
  //         });
  //         return m;
  //       })
  //       .catch(() => dispatch({ type: "REQUEST_ERROR" }));
  //     dispatch({
  //       type: "UPDATE_QUERY",
  //       payload: /*query*/ {
  //         skip: requestedSkip,
  //         take: take,
  //         startDate,
  //         endDate,
  //       },
  //     });
  //     return resultPromise;
  //   }
  // };

  // // console.log("TABLE: useEffect loadData");
  // useEffect(() => loadData());

  // const { rows, skip, totalCount, loading } = state;

  // const rows = chartData;
  // console.log("chartData");
  // console.log(chartData);
  const columns: Column[] = [
    {
      id: "time",
      label: "Time",
      width: 200,
      format: ({ value }) => (
        <>
          {/* TODO Use row.sourceNode.timeZoneID for formatting! */}
          <FormattedDate
            value={value}
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
          &nbsp;
          <FormattedTime value={value} />
        </>
      ),
    } as Column,
  ].concat(...otherColumns);

  // const [columnWidths, setColumnWidths] = useState(
  //   columns.map((column) => ({
  //     columnName: column.id,
  //     width: column.id === "time" ? 200 : 128,
  //   })) as Array<any/*TableColumnWidthInfo*/>
  // );

  // const page = /*(data.dataPoints && data.dataPoints.page) ||*/ {
  //   __typename: "Page",
  //   size: rows.length, // pageSize,
  //   totalElements: 0,
  //   totalPages: 0,
  //   number: currentPage,
  // };

  // const totalCount = totalElements ? totalElements : rows ? rows.length : 0; // TODO improve this!

  // const page = /*(data.dataPoints && data.dataPoints.page) ||*/ {
  //   __typename: "Page",
  //   size: rows.length, // pageSize,
  //   totalElements: 0,
  //   totalPages: 0,
  //   number: currentPage,
  // };
  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  // // If there are more items to be loaded then add an extra row to hold a loading indicator.
  // const rowCount = totalCount; // hasNextPage ? rows.length + 1 : rows.length;

  // // Only load 1 page of items at a time.
  // // Pass an empty callback to InfiniteLoader in case it asks us to load more than once.
  // const loadMoreRows = loading ? () => {} : ({startIndex, stopIndex}: IndexRange) => getRemoteRows(startIndex, stopIndex - startIndex);

  // // Every row is loaded except for our loading indicator row.
  // const isRowLoaded = ({index}: any) => !hasNextPage || index < rows.length;

  // TODO This variables part is Apollo specificy
  const variables: any = {
    panelId,
    nodes: n,
    startDate,
    endDate,
  };
  // if (sorting && sorting.length > 0) {
  //   // TODO multisort?
  //   variables.orderBy = sorting.map(
  //     (s) => `${s.columnName}_${s.direction.toUpperCase()}`
  //   )[0];
  // }
  if (pageSize && pageSize > 0) {
    variables.take = /* TODO currentPage * ??? */ pageSize;
  }
  // TODO variables.after
  if (currentPage && currentPage > 0) {
    variables.skip = currentPage * pageSize;
  }

  // if (JSON.stringify(variables) !== JSON.stringify(newVariables)) {
  //   setVariables(newVariables);
  // }

  const { data /*, error, loading*/ } = useQuery(TrendValues, {
    variables,
  });

  //     const resultPromise = client
  //       .query({
  //         query: TrendValues,
  //         variables: {
  //           panelId,
  //           nodes: n,
  //           startDate,
  //           endDate,
  //           skip: requestedSkip,
  //           take,
  //         }, // FIXME requestedSkip, take
  //       })
  //       .then(({ data }: any) => {
  //         const m = mergeSeries(data.dataSeries).sort(
  //           (a, b) => b.time - a.time
  //         );
  //         // console.log("will fire UPDATE_ROWS with ", data, "merged: ", m);
  //         dispatch({
  //           type: "UPDATE_ROWS",
  //           payload: {
  //             skip: requestedSkip,
  //             rows: m,
  //             totalCount: m.length < take ? requestedSkip + m.length : MAX_ROWS,
  //           },
  //         });
  //         return m;
  //       })

  // if (error) return `Error! ${error.message}`;

  const rows =
    data && data.dataSeries
      ? mergeSeries(data.dataSeries).sort((a, b) => b.time - a.time)
      : undefined;

  const totalCount = rows
    ? rows.length < pageSize
      ? currentPage * pageSize + rows.length
      : (currentPage + 1) * pageSize + 1
    : 0;

  return (
    <TableContainer className={classes.container}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                // align={column.align}
                style={{ minWidth: column.width }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows && rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No data
              </TableCell>
            </TableRow>
          )}
          {rows &&
            rows.map((row: any) => (
              <TableRow key={row.id}>
                {columns.map((column) => {
                  const value = row[column.id];
                  return (
                    <TableCell
                      key={column.id}
                      // align={column.align}
                      style={{ minWidth: column.width }}
                    >
                      {column.format ? column.format({ value, row }) : value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          {/* {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={columns.length} />
            </TableRow>
          )} */}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                // , { label: 'All', value: -1 }
              ]}
              colSpan={columns.length}
              count={totalCount}
              rowsPerPage={pageSize}
              page={currentPage}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              // ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
  // return (
  // <Grid
  //   rows={rows}
  //   columns={columns}
  //   /*getRowId={getRowId}*/ rootComponent={Root}
  // >
  //   <DataTypeProvider
  //     formatterComponent={({ value }) => (
  //       <Fragment>
  //         <FormattedDate
  //           value={value}
  //           year="numeric"
  //           month="2-digit"
  //           day="2-digit"
  //         />
  //         &nbsp;
  //         <FormattedTime value={value} />
  //       </Fragment>
  //     )}
  //     for={["time"]}
  //   />
  //   <PagingState
  //     currentPage={page.number}
  //     onCurrentPageChange={(newCurrentPage) => {
  //       setCurrentPage(newCurrentPage);
  //     }}
  //     pageSize={page.size}
  //   />
  //   <CustomPaging totalCount={page.totalElements} />
  //   {/* <Table /> */}

  //   <VirtualTableState
  //     loading={loading}
  //     totalRowCount={totalCount}
  //     pageSize={VIRTUAL_PAGE_SIZE}
  //     skip={skip}
  //     getRows={getRemoteRows}
  //     infiniteScrolling={false} // TODO is false correct?
  //     // infiniteScrolling={true} // TODO is false correct?
  //   />
  //   <VirtualTable
  //     height="auto" /*columnExtensions={tableColumnExtensions}*/
  //   />
  //   <TableColumnResizing
  //     columnWidths={columnWidths}
  //     onColumnWidthsChange={setColumnWidths}
  //   />
  //   <TableHeaderRow />
  //   <TableColumnVisibility
  //     columnTogglingEnabled={!widgetStatic}
  //     hiddenColumnNames={hiddenColumnNames}
  //     onHiddenColumnNamesChange={(newHiddenColumnNames) => {
  //       setHiddenColumnNames(newHiddenColumnNames);
  //     }}
  //   />
  //   {!widgetStatic && <Toolbar />}
  //   {!widgetStatic && <ColumnChooser />}
  //   {/* <PagingPanel /> */}
  // </Grid>
  // );
}

export default TrendTableMui;
